export default __webpack_public_path__ + "static/media/W_Wood.d5998fb6.jpg";